import {
	getMomentTz,
	MESApiService,
	type spParameter,
} from "@dexteel/mesf-core";

export interface Task {
	id?: number;
	WorkOrderId?: number;
	RootAssetId: number | null;
	AssetName?: string;
	AssetId?: number;
	Title?: string;
	DownHours?: number | null;
	CraftName?: string | null;
	CraftColor?: string | null;
	CraftId?: number;
	TypeCode?: string | null;
	Comments?: null | string;
	Close?: number;
	Ordinal?: number;
	Priority?: number;
	WorkOrderStatusCode?: string;
	OpenTimestamp?: Date;
	RunningTime?: number;
	TemplateTitle?: null | string;
	WorkOrderName?: string;
	WorkOrderPlannedHours?: number | null;
	WorkOrderNumberOfWorkers?: number | null;
	WorkOrderOpenedBy?: string;
	AttachmentsLinked?: number;
	FullPath?: string;
	Table?: number;
	TableName?: string;
}

const moment = getMomentTz();

export const GetTaskListByArea = async (
	craftSearchId: string[],
	typeSearchId: string | null,
	searchText: string | null,
	searchDownHours: number | string | null,
	assetSearchId: number | string | null,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	// Handle craft filter
	if (craftSearchId && !craftSearchId.includes("A")) {
		parameters.push({
			name: "CraftIds",
			value: craftSearchId.join(","),
		});
	} else {
		parameters.push({ name: "CraftIds", value: null });
	}

	if (typeSearchId !== "A") {
		parameters.push({ name: "TypeCode", value: typeSearchId });
	} else {
		parameters.push({ name: "TypeCode", value: null });
	}

	parameters.push({ name: "SearchText", value: searchText });
	parameters.push({
		name: "DownHours",
		value: searchDownHours === "" ? null : searchDownHours,
	});
	parameters.push({ name: "AssetId", value: assetSearchId });

	const resp = await apiService.callV2("[MMS].[GetTaskListByArea]", parameters);

	if (resp.ok) {
		resp.data.tables[0].rows = resp.data.tables[0].rows.map((row: Task) => {
			return {
				...row,
				OpenTimestamp: row.OpenTimestamp
					? moment.utc(row.OpenTimestamp).toDate()
					: null,
			};
		});
	}

	return resp;
};

export const getCrafts = async () => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[MMS].[GetCrafts]", []);
	return resp;
};

export const UpdateTaskListPriority = async (
	WorkOrderIdToMove: number,
	WorkOrderIdMoveBelow: number | null,
	SetDownTimeWorkOrder: any | null,
) => {
	const apiService = new MESApiService();
	const parameters = [];

	parameters.push({ name: "WorkOrderIdToMove", value: WorkOrderIdToMove });
	parameters.push({
		name: "WorkOrderIdMoveBelow",
		value: WorkOrderIdMoveBelow,
	});
	parameters.push({
		name: "SetDownTimeWorkOrder",
		value: SetDownTimeWorkOrder === null ? null : SetDownTimeWorkOrder,
	});

	const resp = await apiService.callV2(
		"[MMS].[UpdateTaskListPriority]",
		parameters,
	);
	return resp;
};
